import { jsx as _jsx } from "react/jsx-runtime";
import { IconPredefined } from '@snack-uikit/icon-predefined';
import { TEST_IDS } from '../../constants';
import { useCardContext } from '../../context';
import styles from './styled.module.css';
function isPictureProps(props) {
    return 'src' in props && 'alt' in props;
}
export function Emblem(props) {
    var _a, _b, _c;
    const { size } = useCardContext();
    if (isPictureProps(props)) {
        return (_jsx("img", { src: props.src, alt: props.alt, "data-size": size || undefined, className: styles.img, "data-test-id": TEST_IDS.emblemPicture }));
    }
    return (_jsx(IconPredefined, { icon: props.icon, appearance: (_a = props.appearance) !== null && _a !== void 0 ? _a : 'primary', decor: (_b = props.decor) !== null && _b !== void 0 ? _b : true, size: size, shape: (_c = props.shape) !== null && _c !== void 0 ? _c : 'round', "data-test-id": TEST_IDS.emblemIcon }));
}
